import { useEffect, useMemo, useState } from "react";
import { IMenuOption } from "../../../types/global";
import { useTranslation } from "react-i18next";

export const useSalesInvoiceOption = (status?: string | null) => {
  const { t } = useTranslation();
  const defaultOptions: IMenuOption[] = useMemo(
    () => [
      {
        value: "แก้ไข",
        disabled: false,
      },
      {
        value: "คัดลอก",
        disabled: false,
      },
      {
        value: "ยกเลิก",
        disabled: false,
      },
    ],
    []
  );

  const [selectModifyOptions, setSelectedModifyOptions] =
    useState<IMenuOption[]>(defaultOptions);

  useEffect(() => {
    switch (status) {
      case "draft":
      case "not_approved":
        setSelectedModifyOptions([defaultOptions[1], defaultOptions[2]]); //ยกเลิก, คักลอก
        break;
      case "cancelled":
      case "finished":
        setSelectedModifyOptions([defaultOptions[1]]); //คักลอก
        break;
      case "wait_payment":
      case "partially_payment":
      case "fully_payment":
        setSelectedModifyOptions([
          {
            value: t("sales.external_reference_no"),
            disabled: false,
          },
          ...defaultOptions,
        ]);
        break;
      default:
        setSelectedModifyOptions(defaultOptions);
        break;
    }
  }, [defaultOptions, status, t]);

  return selectModifyOptions;
};
